// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.Model = M.Model || {};
M.Model.ProductDetails = M.Model.ProductDetails || {};

/**
 * @class M.Model.ProductDetails.Accessory
 *
 * Model for a single accessory option on the product details page.
 *  "id": 30,
 *  "code": "J",
 *  "name": "rounded-corners-a7",
 *  "orientation": "landscape"
 */
M.Model.ProductDetails.Shape = Backbone.Model.extend({

  /**
   * Returns the formatted shape css class name.
   */
  getOrientationCssClass: function() {
    if (this.get('orientation') == 'landscape') {
      return 'dieCutLandscape';
    } else if (this.get('orientation') == 'portrait') {
      return 'dieCutPortrait';
    } else {
      return 'dieCutSquare';
    }
  }

});
